import React from 'react'
import {  Grid } from "@mui/material";
import CustomButton from "../../shared/CustomButton";
import CustomDateTimePicker from '../../shared/CustomDateTimePicker'
import FormikAutocomplete from '../../shared/AutoCompelete';
import FormikMultiple from '../../shared/FormikMultiple'

export const MatchingFilter = ({formik}) => {

  const test = [{id:1 , name:"tss"},{id:2,name:"2"}]
  return (
    <Grid
    container
    justifyContent="flex-start"
    alignItems="inhirte"
    gap="20px"
    sx={{ 
      padding: "20px 20px 5px 20px",
      
borderBottom: "1px solid #E7E9EF",
background: "#fff",
   }}
  >
   <Grid item>
       
       <CustomDateTimePicker
         width={230}
         inputwidth={230}
         label="Start Date/Time"
         name="dateFrom"
         dateValue={formik.values.dateFrom}
         formik={formik}
       />
     
         
      
     </Grid>

     <Grid item>
     <CustomDateTimePicker
         width={230}
         inputwidth={230}
         label="End Date/Time"
         name="dateTo"
         dateValue={formik.values.dateTo}
         formik={formik}
       />
        
     </Grid>
     <Grid item>
     <FormikMultiple 
 options={test}
 isOptionEqualToValue ={ (option, value) => option.id === value.id}
 getOptionLabel={(option) => option.name}
 value={formik.values.RuleName}
 formik={formik}
 name="RuleName"
 text="Assign to group"
width={230}
validationOn={true}
/>

     </Grid>
    <Grid>
   
          <CustomButton
            text="Apply"
            processing={false}
            disabled={false}
            action = {formik.handleSubmit}
          />
    </Grid>
  </Grid>
  )
}
